import React from 'react';
import { ArrowRightOutlined, BankOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import './index.scss';

const SchoolNotice = () => (
  <section className="schoolNotice" aria-label="选择学校引导">
    <div className="schoolNotice-icon" aria-hidden="true"><BankOutlined /></div>
    <div className="schoolNotice-copy">
      <h2>选择学校，发现同校搭子</h2>
      <p>在个人资料中选择学校后，即可浏览同校帖子、获取推荐和发布招募。</p>
    </div>
    <Link className="schoolNotice-action" to="/personal/info">
      去选择学校 <ArrowRightOutlined aria-hidden="true" />
    </Link>
  </section>
);
export default SchoolNotice;
